/* istanbul ignore file */
import BarChart from 'components/highcharts/BarChart';
import usePmProvider from 'components/hooks/PM/usePmProvider';
import { getXAxisLabel, labelBuilder } from '../custom-report.serivce';
import { getToolTipTitleByDateRange, toolTipFormatter } from '../Tooltip';

const CustomReportBarChart = ({
  searchRange,
  yData,
  onPointClick,
  displayName,
  yFormatter,
  granularity,
  graphColor,
  displayLabel,
  percentOffName,
  overridePercentName,
  metricName,
  isPmCustomDashboard,
  isReportedMetric,
  widgetFilters,
  getEndDateForTooltip,
  metricsCalculationConfig = {},
  workingDaysSetting
}) => {
  const pmProvider = usePmProvider();
  const data =
    searchRange?.reduce((acc, cur, index) => {
      acc[cur.before] = [yData[index] ?? 0];
      return acc;
    }, {}) ?? {};

  return (
    <BarChart
      rotation={-45}
      tickInterval={null}
      data={data}
      onPointClick={onPointClick}
      tooltipLabels={[displayName]}
      yProps={{ formatter: yFormatter, titleProps: { text: '' } }}
      xProps={{
        gridLineWidth: 0,
        categories: searchRange,
        formatter(value) {
          return getXAxisLabel(
            value.after,
            value.before,
            granularity,
            value.name,
            workingDaysSetting
          );
        }
      }}
      barColor={graphColor || 'dodgerBlue'}
      tooltipProps={{
        disabled: true,
        outside: true,
        formatter(x, y, percentage, rawData, currentPercentage) {
          const displayEndDate = getEndDateForTooltip(x.before);
          return toolTipFormatter({
            title: getToolTipTitleByDateRange(
              x.after,
              displayEndDate,
              granularity,
              x.name
            ),
            data: yFormatter ? yFormatter(y, 2) : y,
            label: labelBuilder(
              displayLabel,
              percentage,
              percentOffName,
              overridePercentName,
              metricName,
              metricsCalculationConfig
            ),
            rawData,
            metricName,
            isPmCustomDashboard,
            isReportedMetric,
            currentPercentage,
            pmProvider,
            widgetFilters
          });
        }
      }}
    />
  );
};

export default CustomReportBarChart;
